// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__L-8Mp","author":"Table_author__1HvIu","authorImage":"Table_authorImage__17Hgf","unreadRow":"Table_unreadRow__2tvK0"};